module.exports = "./img/0d2b4a09de34cf35a4c66b3f4d52a35c.jpg";